/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { CityApiDto } from '../model/city.model';
// @ts-ignore
import { CountryApiDto } from '../model/country.model';
// @ts-ignore
import { CountryWeightApiDto } from '../model/country-weight.model';
// @ts-ignore
import { DefaultErrorMessageApiDto } from '../model/default-error-message.model';
// @ts-ignore
import { DestinationCityFilterApiDto } from '../model/destination-city-filter.model';
// @ts-ignore
import { DestinationCountryFilterApiDto } from '../model/destination-country-filter.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';
import { DestinationControllerApiServiceInterface } from './destination-controller.serviceInterface';

@Injectable({
  providedIn: 'root',
})
export class DestinationControllerApiService extends BaseService implements DestinationControllerApiServiceInterface {
  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration?: Configuration) {
    super(basePath, configuration);
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findDestinationCitiesByFilter(
    filter: DestinationCityFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<CityApiDto>>;
  public findDestinationCitiesByFilter(
    filter: DestinationCityFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<CityApiDto>>>;
  public findDestinationCitiesByFilter(
    filter: DestinationCityFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<CityApiDto>>>;
  public findDestinationCitiesByFilter(
    filter: DestinationCityFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling findDestinationCitiesByFilter.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling findDestinationCitiesByFilter.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling findDestinationCitiesByFilter.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/products/v2/destinations/cities`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<CityApiDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param filter
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findDestinationCountriesByFilter(
    filter: DestinationCountryFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<CountryApiDto>>;
  public findDestinationCountriesByFilter(
    filter: DestinationCountryFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<CountryApiDto>>>;
  public findDestinationCountriesByFilter(
    filter: DestinationCountryFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<CountryApiDto>>>;
  public findDestinationCountriesByFilter(
    filter: DestinationCountryFilterApiDto,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (filter === null || filter === undefined) {
      throw new Error('Required parameter filter was null or undefined when calling findDestinationCountriesByFilter.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling findDestinationCountriesByFilter.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling findDestinationCountriesByFilter.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filter, 'filter');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/products/v3/destinations/countries`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<CountryApiDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getQuoteToolCountryWeights(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<CountryWeightApiDto>>;
  public getQuoteToolCountryWeights(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<CountryWeightApiDto>>>;
  public getQuoteToolCountryWeights(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<CountryWeightApiDto>>>;
  public getQuoteToolCountryWeights(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling getQuoteToolCountryWeights.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling getQuoteToolCountryWeights.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/products/v3/destinations/countries/quote-tool-weights`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<CountryWeightApiDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
